import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

@Component({
    selector: 'toggle-password-button',
    templateUrl: './toggle-password.component.html',
    styleUrls: ['./toggle-password.component.scss'],
    standalone: false
})
export class TogglePasswordButton implements OnInit, OnChanges {
  @Input() showPassword: boolean = false;
  @Output() onIconClick = new EventEmitter<void>();

  private _openEyeIcon = 'assets/images/icons/eye.svg'
  private _closeEyeIcon = 'assets/images/icons/eye-close.svg'
  icon: string = this._openEyeIcon

  ngOnInit(): void {
    this._updateIcon()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showPassword']) {
      this._updateIcon();
    }
  }

  private _updateIcon() {
    this.icon = this.showPassword ? this._closeEyeIcon : this._openEyeIcon
  }

  onClick(e: MouseEvent) {
    this.onIconClick.emit()

    e.preventDefault()
  }
}